import {
  translateSingleString as remoteTranslateSingleString,
  translationDetails,
} from '@paywithextend/localization'

export type TranslateFn = (
  source: string,
  expressions?: Record<string, string> | undefined,
) => string

export function createTranslate(
  localeTranslations: Record<string, translationDetails>,
  defaultTranslations: Record<string, translationDetails>,
): TranslateFn {
  return remoteTranslateSingleString(localeTranslations, defaultTranslations)
}
